import { Spin } from "antd";

function OnboardingLoader() {
  return (
    <div
      className="loader-container"
      style={{
        position: "fixed", // Or 'absolute' depending on parent container
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "white", // Set background to white
        padding: "20px", // Optional: Add padding around the spinner
        borderRadius: "8px", // Optional: Add rounded corners
        zIndex: 9999, // Ensure it's on top
      }}
    >
      <Spin size="large" />
    </div>
  );
}

export default OnboardingLoader;
